const updateType = {
    delete: 'DELETE',
    update: 'UPDATE',
    create: "CREATE"
}

export default updateType